import React from "react";

import { Box, Link, Icon, IconButton, Divider, Card, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import LinkIcon from '@mui/icons-material/Link';

// common
import { dic } from "@common/text_defs";
// component

const DhxIntraSection = () => {

  const cardList = [
    {
      icon: "account_balance",
      text: "支店・子会社にあるデータを収集・分析して本社で統合管理",
    },
    {
      icon: "payment",
      text: "部門ごとに管理しているデータを統合管理することで内部統制",
    },
    {
      icon: "receipt",
      text: "社外からデータを簡単に一元管理して業務を効率化",
    },
    {
      icon: "cloud_done",
      text: "統合したデータをレポート、データの可視化が実現可能",
    },
  ];
  return (
    <Box component="section" className="section-service3 bg-light-gray" sx={{ mt: 5 }}>
      <Box component="div" className="container">
        <Grid container spacing={5} alignItems="flex-start">
          <Grid lg={6} md={6} sm={12}>
            <h2 className="">データ連携・統合より、データの有効活用と業務効率化</h2>
            <p>
              データ統合・連携基盤構築サービスは、いろんな場所で分散する様々なフォーマットのデータを収集して、
              社内外の様々なシステムのデータ連携を実現します。
              連携先のシステムに適したフォーマットに加工・出力し、
              お客様の要望やデータ量にあわせて柔軟に処理性能を拡張・カスタマイズすることができるデータ統合基盤です。
            </p>
          </Grid>
          <Grid lg={6} md={6} sm={12}>
            <Grid container spacing={4}>
              {cardList.map((card, index) => (
                <Grid lg={6} md={6} sm={6} xs={12} key={index} sx={{ maxWidth: '280px' }}>
                  <Card className="service__card p-6 card text-center h-full">
                    <p className="m-0 uppercase">{card.text} </p>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export { DhxIntraSection };
